const getDefaultState = () => {
  return {
    passwordReg: /^[0-9A-Za-z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,32}$/,
    nameReg:
      /^[^\#\$\￥\%\^\&\*\……\~\`\|\【\】\》\《\'\!\！\{\}\‘\“\”\’\/\、\?\？\——\=\+\@]*$/,
    codeReg: /^[0-9]{6}$/,
    areaReg: /^[0-9]{0,4}$/,
    certiReg: /^[0-9a-zA-Z]{1,20}$/,
    telReg: /^[0-9\-]{6,20}$/,
    idCardReg: /^[0-9a-zA-Z\.]{1,18}$/,
    cardNoReg: /^[a-zA-Z0-9]{1,10}$/,
    sysReg: /^[a-zA-z\_\-\.\@\-0-9]*$/,
    //  用户中心后台校验规则

    emailReg: /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.([A-Za-z]{2,4})$/,
    accountReg: /^(?=.*[A-Za-z])[0-9A-Za-z\-]{5,20}$/,
    notAllZoneIpReg:
      /^(?!0\.0\.0\.0)(\b(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, // 排除0.0.0.0的ip规则
    ipReg:
      /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/, // 针对网关、子网掩码、dns的
    ipReg1:
      /^(([1-9]|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){1}((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-4])\.){2}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-3])$/, // 针对ip地址限制 255.254.254.253 各段上限
    isIpReg: /^[0-9.]+$/, // 判断是否是ip
    hostReg: /^([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/, // 域名正则表达式
  };
};

const state = getDefaultState();
export const commonState = state;

export default {
  namespaced: true,
  state,
};
